var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('ClientOnly',[_c(_vm.externalReviewComponent,{tag:"component",attrs:{"data-test":"external-reviews-component","hidden":_vm.isAtBottom,"is-mobile":_vm.isMobile}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }